module.exports = __webpack_public_path__ + "static/media/Tier_2.104d9f2b.png";